import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const postUploadDomainSlice = createApi(`PostUploadDomainSlice`,"POST");

const PostUploadDomainSlice = createSlice({
  name: 'PostUploadDomainSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postUploadDomainSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postUploadDomainSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postUploadDomainSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default PostUploadDomainSlice.reducer;